import { Injectable } from "@angular/core";

import { CurrencyService } from "./currency.service";
import { Fiat } from "@models";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InitService } from "@core-services/init.service";
import { ServiceNames } from "@models/service_enums";

const name = ServiceNames.FIAT;

@Injectable({
	providedIn: "root"
})
export class FiatService extends CurrencyService<Fiat> {
	public name: string = ServiceNames.FIAT;

	public constructor(
		protected initService: InitService,
		protected destructor: DestructorService,
		protected translationService: TranslationService
	) {
		super(initService, destructor, translationService, name);
	}

	protected filteredList(): Fiat[] {
		return this.list.filter((f: Fiat) => f.hasWallet());
	}

	public initFiat(): void {
		this.initService.init(this.name);
	}

	public findById(id): Fiat {
		return this.list.find((w) => w.getId() === id);
	}

	public findByPid(pid: string): Fiat {
		return this.list.find((w) => w.getPid() === pid);
	}
}
